import React from "react";
import { useSelector } from "react-redux";
import AsyncSelect from "react-select/async";
import { getUsers } from "../../../../api";

export default function CollaboratorsSelect({
  isMulti,
  selectedCollaborator,
  organizationId,
  onChange,
}) {
  const token = useSelector((state) => state.auth.token);

  const fetchCollaborators = (inputValue) => {
    return getUsers({
      token,
      organizationId,
      search: inputValue,
      sort: [{ property: "lastName", dir: "asc" }],
    }).then((result) => {
      return result.data.data;
    });
  };

  return (
    <div>
      <AsyncSelect
        isMulti={isMulti}
        cacheOptions
        value={selectedCollaborator}
        onChange={(e) => onChange(e)}
        loadOptions={fetchCollaborators}
        defaultOptions={true}
        getOptionLabel={(option) => `${option.firstName} ${option.lastName}`}
        getOptionValue={(option) => option.id}
        classNamePrefix="custom-select"
      />
    </div>
  );
}
